/* To register all assessments inside the application */
export const Assessment_Types =  {
  Gait: Symbol(0),
  Fivex_STS: Symbol(1)
}
